module.exports = __webpack_public_path__ + "img/Pose de fenêtre pvc avec habillage intérieur et extérieur.0472532b.jpg";